import { render, staticRenderFns } from "./Fat.vue?vue&type=template&id=7322fbc2"
import script from "./Fat.vue?vue&type=script&lang=js"
export * from "./Fat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports